var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-col",
        [
          _c(
            "el-form",
            {
              ref: "sizeFormBar",
              attrs: {
                model: _vm.sizeForm,
                "label-width": "80px",
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("barDefault"),
                      expression: "showProperty('barDefault')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.adapt") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("barDefault")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.barDefault,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "barDefault", $$v)
                        },
                        expression: "sizeForm.barDefault",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.adapt")))]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("barWidth"),
                      expression: "showProperty('barWidth')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.bar_width") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      disabled: _vm.sizeForm.barDefault,
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 1,
                      max: 80,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("barWidth")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.barWidth,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "barWidth", $$v)
                      },
                      expression: "sizeForm.barWidth",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("barGap"),
                      expression: "showProperty('barGap')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.bar_gap") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      disabled: _vm.sizeForm.barDefault,
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 0,
                      max: 5,
                      step: 0.1,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("barGap")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.barGap,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "barGap", $$v)
                      },
                      expression: "sizeForm.barGap",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("lineWidth"),
                      expression: "showProperty('lineWidth')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.line_width") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 0,
                      max: 10,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("lineWidth")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.lineWidth,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "lineWidth", $$v)
                      },
                      expression: "sizeForm.lineWidth",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("lineType"),
                      expression: "showProperty('lineType')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.line_type") },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("lineType")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.lineType,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "lineType", $$v)
                        },
                        expression: "sizeForm.lineType",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "solid" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.line_type_solid"))),
                      ]),
                      _c("el-radio-button", { attrs: { label: "dashed" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.line_type_dashed"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("lineSymbol"),
                      expression: "showProperty('lineSymbol')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.line_symbol") },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("chart.line_symbol") },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("lineSymbol")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.lineSymbol,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "lineSymbol", $$v)
                        },
                        expression: "sizeForm.lineSymbol",
                      },
                    },
                    _vm._l(_vm.lineSymbolOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.name, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("lineSymbolSize"),
                      expression: "showProperty('lineSymbolSize')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.line_symbol_size") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 0,
                      max: 20,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("lineSymbolSize")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.lineSymbolSize,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "lineSymbolSize", $$v)
                      },
                      expression: "sizeForm.lineSymbolSize",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("lineSmooth"),
                      expression: "showProperty('lineSmooth')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.line_smooth") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("lineSmooth")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.lineSmooth,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "lineSmooth", $$v)
                        },
                        expression: "sizeForm.lineSmooth",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.line_smooth")))]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("pieInnerRadius"),
                      expression: "showProperty('pieInnerRadius')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.pie_inner_radius") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 0,
                      max: 100,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("pieInnerRadius")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.pieInnerRadius,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "pieInnerRadius", $$v)
                      },
                      expression: "sizeForm.pieInnerRadius",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("pieOuterRadius"),
                      expression: "showProperty('pieOuterRadius')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.pie_outer_radius") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 0,
                      max: 100,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("pieOuterRadius")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.pieOuterRadius,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "pieOuterRadius", $$v)
                      },
                      expression: "sizeForm.pieOuterRadius",
                    },
                  }),
                ],
                1
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.showProperty("pieRoseType") ||
                        _vm.showProperty("pieRoseRadius"),
                      expression:
                        "showProperty('pieRoseType') || showProperty('pieRoseRadius') ",
                    },
                  ],
                },
                [
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("pieRoseType"),
                          expression: "showProperty('pieRoseType')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.rose_type") },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "mini" },
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase("pieRoseType")
                            },
                          },
                          model: {
                            value: _vm.sizeForm.pieRoseType,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm, "pieRoseType", $$v)
                            },
                            expression: "sizeForm.pieRoseType",
                          },
                        },
                        [
                          _c(
                            "el-radio-button",
                            { attrs: { label: "radius" } },
                            [_vm._v(_vm._s(_vm.$t("chart.radius_mode")))]
                          ),
                          _c("el-radio-button", { attrs: { label: "area" } }, [
                            _vm._v(_vm._s(_vm.$t("chart.area_mode"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("pieRoseRadius"),
                          expression: "showProperty('pieRoseRadius')",
                        },
                      ],
                      staticClass: "form-item form-item-slider",
                      attrs: { label: _vm.$t("chart.rose_radius") },
                    },
                    [
                      _c("el-slider", {
                        attrs: {
                          "show-input": "",
                          "show-input-controls": false,
                          "input-size": "mini",
                          min: 0,
                          max: 100,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeBarSizeCase("pieRoseRadius")
                          },
                        },
                        model: {
                          value: _vm.sizeForm.pieRoseRadius,
                          callback: function ($$v) {
                            _vm.$set(_vm.sizeForm, "pieRoseRadius", $$v)
                          },
                          expression: "sizeForm.pieRoseRadius",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("funnelWidth"),
                      expression: "showProperty('funnelWidth')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.funnel_width") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 0,
                      max: 100,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("funnelWidth")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.funnelWidth,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "funnelWidth", $$v)
                      },
                      expression: "sizeForm.funnelWidth",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("radarShape"),
                      expression: "showProperty('radarShape')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.shape") },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "mini" },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("radarShape")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.radarShape,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "radarShape", $$v)
                        },
                        expression: "sizeForm.radarShape",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "polygon" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.polygon"))),
                      ]),
                      _c("el-radio-button", { attrs: { label: "circle" } }, [
                        _vm._v(_vm._s(_vm.$t("chart.circle"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("radarSize"),
                      expression: "showProperty('radarSize')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.radar_size") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 0,
                      max: 100,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("radarSize")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.radarSize,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "radarSize", $$v)
                      },
                      expression: "sizeForm.radarSize",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("tablePageMode"),
                      expression: "showProperty('tablePageMode')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: {
                    "label-width": "100px",
                    label: _vm.$t("chart.table_page_mode"),
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("chart.table_page_mode") },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("tablePageMode")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.tablePageMode,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "tablePageMode", $$v)
                        },
                        expression: "sizeForm.tablePageMode",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("chart.page_mode_page"),
                          value: "page",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("chart.page_mode_pull"),
                          value: "pull",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.showProperty("tablePageSize") &&
                        _vm.sizeForm.tablePageMode === "page",
                      expression:
                        "showProperty('tablePageSize') && sizeForm.tablePageMode === 'page'",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: {
                    "label-width": "100px",
                    label: _vm.$t("chart.table_page_size"),
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("chart.table_page_size") },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("tablePageSize")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.tablePageSize,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "tablePageSize", $$v)
                        },
                        expression: "sizeForm.tablePageSize",
                      },
                    },
                    _vm._l(_vm.pageSizeOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.name, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("tableTitleFontSize"),
                      expression: "showProperty('tableTitleFontSize')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: {
                    "label-width": "100px",
                    label: _vm.$t("chart.table_title_fontsize"),
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("chart.table_title_fontsize"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("tableTitleFontSize")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.tableTitleFontSize,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "tableTitleFontSize", $$v)
                        },
                        expression: "sizeForm.tableTitleFontSize",
                      },
                    },
                    _vm._l(_vm.fontSize, function (option) {
                      return _c("el-option", {
                        key: option.value,
                        attrs: { label: option.name, value: option.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("tableItemFontSize"),
                      expression: "showProperty('tableItemFontSize')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: {
                    "label-width": "100px",
                    label: _vm.$t("chart.table_item_fontsize"),
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("chart.table_item_fontsize"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("tableItemFontSize")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.tableItemFontSize,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "tableItemFontSize", $$v)
                        },
                        expression: "sizeForm.tableItemFontSize",
                      },
                    },
                    _vm._l(_vm.fontSize, function (option) {
                      return _c("el-option", {
                        key: option.value,
                        attrs: { label: option.name, value: option.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("tableTitleHeight"),
                      expression: "showProperty('tableTitleHeight')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: {
                    "label-width": "100px",
                    label: _vm.$t("chart.table_title_height"),
                  },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      min: 36,
                      max: 100,
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("tableTitleHeight")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.tableTitleHeight,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "tableTitleHeight", $$v)
                      },
                      expression: "sizeForm.tableTitleHeight",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("tableItemHeight"),
                      expression: "showProperty('tableItemHeight')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: {
                    "label-width": "100px",
                    label: _vm.$t("chart.table_item_height"),
                  },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      min: 36,
                      max: 100,
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("tableItemHeight")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.tableItemHeight,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "tableItemHeight", $$v)
                      },
                      expression: "sizeForm.tableItemHeight",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("tableColumnWidth"),
                      expression: "showProperty('tableColumnWidth')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: {
                    "label-width": "100px",
                    label: _vm.$t("chart.table_column_width_config"),
                  },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      min: 10,
                      max: 1000,
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("tableColumnWidth")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.tableColumnWidth,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "tableColumnWidth", $$v)
                      },
                      expression: "sizeForm.tableColumnWidth",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("showIndex"),
                      expression: "showProperty('showIndex')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: {
                    "label-width": "100px",
                    label: _vm.$t("chart.table_show_index"),
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { "input-size": "mini" },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("showIndex")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.showIndex,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "showIndex", $$v)
                        },
                        expression: "sizeForm.showIndex",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v(_vm._s(_vm.$t("panel.yes"))),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v(_vm._s(_vm.$t("panel.no"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.showProperty("indexLabel") &&
                        _vm.sizeForm.showIndex,
                      expression:
                        "showProperty('indexLabel') && sizeForm.showIndex",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: {
                    "label-width": "100px",
                    label: _vm.$t("chart.table_index_desc"),
                  },
                },
                [
                  _c("el-input", {
                    attrs: { type: "text" },
                    on: {
                      blur: function ($event) {
                        return _vm.changeBarSizeCase("indexLabel")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.indexLabel,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "indexLabel", $$v)
                      },
                      expression: "sizeForm.indexLabel",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("gaugeMin"),
                      expression: "showProperty('gaugeMin')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.min") },
                },
                [
                  _c("el-input-number", {
                    attrs: { size: "mini" },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("gaugeMin")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.gaugeMin,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "gaugeMin", $$v)
                      },
                      expression: "sizeForm.gaugeMin",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("gaugeMax"),
                      expression: "showProperty('gaugeMax')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.max") },
                },
                [
                  _c("el-input-number", {
                    attrs: { size: "mini" },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("gaugeMax")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.gaugeMax,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "gaugeMax", $$v)
                      },
                      expression: "sizeForm.gaugeMax",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("gaugeStartAngle"),
                      expression: "showProperty('gaugeStartAngle')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.start_angle") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: -360,
                      max: 360,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("gaugeStartAngle")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.gaugeStartAngle,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "gaugeStartAngle", $$v)
                      },
                      expression: "sizeForm.gaugeStartAngle",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("gaugeEndAngle"),
                      expression: "showProperty('gaugeEndAngle')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.end_angle") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: -360,
                      max: 360,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("gaugeEndAngle")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.gaugeEndAngle,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "gaugeEndAngle", $$v)
                      },
                      expression: "sizeForm.gaugeEndAngle",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("quotaFontSize"),
                      expression: "showProperty('quotaFontSize')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.quota_font_size") },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("chart.quota_font_size") },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("quotaFontSize")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.quotaFontSize,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "quotaFontSize", $$v)
                        },
                        expression: "sizeForm.quotaFontSize",
                      },
                    },
                    _vm._l(_vm.fontSize, function (option) {
                      return _c("el-option", {
                        key: option.value,
                        attrs: { label: option.name, value: option.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("quotaFontFamily"),
                      expression: "showProperty('quotaFontFamily')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.quota_font_family") },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("chart.quota_font_family") },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("quotaFontFamily")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.quotaFontFamily,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "quotaFontFamily", $$v)
                        },
                        expression: "sizeForm.quotaFontFamily",
                      },
                    },
                    _vm._l(_vm.fontFamily, function (option) {
                      return _c("el-option", {
                        key: option.value,
                        attrs: { label: option.name, value: option.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("quotaFontStyle"),
                      expression: "showProperty('quotaFontStyle')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.quota_text_style") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("quotaFontIsItalic")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.quotaFontIsItalic,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "quotaFontIsItalic", $$v)
                        },
                        expression: "sizeForm.quotaFontIsItalic",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.italic")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("quotaFontIsBolder")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.quotaFontIsBolder,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "quotaFontIsBolder", $$v)
                        },
                        expression: "sizeForm.quotaFontIsBolder",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.bolder")))]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("quotaLetterSpace"),
                      expression: "showProperty('quotaLetterSpace')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.quota_letter_space") },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("chart.quota_letter_space"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("quotaLetterSpace")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.quotaLetterSpace,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "quotaLetterSpace", $$v)
                        },
                        expression: "sizeForm.quotaLetterSpace",
                      },
                    },
                    _vm._l(_vm.fontLetterSpace, function (option) {
                      return _c("el-option", {
                        key: option.value,
                        attrs: { label: option.name, value: option.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("quotaFontShadow"),
                      expression: "showProperty('quotaFontShadow')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.font_shadow") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("quotaFontShadow")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.quotaFontShadow,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "quotaFontShadow", $$v)
                        },
                        expression: "sizeForm.quotaFontShadow",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.font_shadow")))]
                  ),
                ],
                1
              ),
              _vm.showProperty("dimensionShow") ? _c("el-divider") : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("dimensionShow"),
                      expression: "showProperty('dimensionShow')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.dimension_show") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("dimensionShow")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.dimensionShow,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "dimensionShow", $$v)
                        },
                        expression: "sizeForm.dimensionShow",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.show")))]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.sizeForm.dimensionShow,
                      expression: "sizeForm.dimensionShow",
                    },
                  ],
                },
                [
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("dimensionFontSize"),
                          expression: "showProperty('dimensionFontSize')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.dimension_font_size") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.dimension_font_size"),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase("dimensionFontSize")
                            },
                          },
                          model: {
                            value: _vm.sizeForm.dimensionFontSize,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm, "dimensionFontSize", $$v)
                            },
                            expression: "sizeForm.dimensionFontSize",
                          },
                        },
                        _vm._l(_vm.fontSize, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("dimensionFontFamily"),
                          expression: "showProperty('dimensionFontFamily')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.dimension_font_family") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.dimension_font_family"),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase(
                                "dimensionFontFamily"
                              )
                            },
                          },
                          model: {
                            value: _vm.sizeForm.dimensionFontFamily,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm, "dimensionFontFamily", $$v)
                            },
                            expression: "sizeForm.dimensionFontFamily",
                          },
                        },
                        _vm._l(_vm.fontFamily, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("dimensionFontStyle"),
                          expression: "showProperty('dimensionFontStyle')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.dimension_text_style") },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase(
                                "dimensionFontIsItalic"
                              )
                            },
                          },
                          model: {
                            value: _vm.sizeForm.dimensionFontIsItalic,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.sizeForm,
                                "dimensionFontIsItalic",
                                $$v
                              )
                            },
                            expression: "sizeForm.dimensionFontIsItalic",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("chart.italic")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase(
                                "dimensionFontIsBolder"
                              )
                            },
                          },
                          model: {
                            value: _vm.sizeForm.dimensionFontIsBolder,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.sizeForm,
                                "dimensionFontIsBolder",
                                $$v
                              )
                            },
                            expression: "sizeForm.dimensionFontIsBolder",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("chart.bolder")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("dimensionLetterSpace"),
                          expression: "showProperty('dimensionLetterSpace')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.dimension_letter_space") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.dimension_letter_space"),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase(
                                "dimensionLetterSpace"
                              )
                            },
                          },
                          model: {
                            value: _vm.sizeForm.dimensionLetterSpace,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.sizeForm,
                                "dimensionLetterSpace",
                                $$v
                              )
                            },
                            expression: "sizeForm.dimensionLetterSpace",
                          },
                        },
                        _vm._l(_vm.fontLetterSpace, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("dimensionFontShadow"),
                          expression: "showProperty('dimensionFontShadow')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.font_shadow") },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase(
                                "dimensionFontShadow"
                              )
                            },
                          },
                          model: {
                            value: _vm.sizeForm.dimensionFontShadow,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm, "dimensionFontShadow", $$v)
                            },
                            expression: "sizeForm.dimensionFontShadow",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("chart.font_shadow")))]
                      ),
                    ],
                    1
                  ),
                  _vm.showProperty("spaceSplit") ? _c("el-divider") : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("spaceSplit"),
                          expression: "showProperty('spaceSplit')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.space_split") },
                    },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, size: "mini" },
                        on: {
                          change: function ($event) {
                            return _vm.changeBarSizeCase("spaceSplit")
                          },
                        },
                        model: {
                          value: _vm.sizeForm.spaceSplit,
                          callback: function ($$v) {
                            _vm.$set(_vm.sizeForm, "spaceSplit", $$v)
                          },
                          expression: "sizeForm.spaceSplit",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("hPosition"),
                          expression: "showProperty('hPosition')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.h_position") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: _vm.$t("chart.h_position") },
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase("hPosition")
                            },
                          },
                          model: {
                            value: _vm.sizeForm.hPosition,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm, "hPosition", $$v)
                            },
                            expression: "sizeForm.hPosition",
                          },
                        },
                        [
                          _c(
                            "el-option",
                            {
                              attrs: {
                                value: "start",
                                label: _vm.$t("chart.p_left"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("chart.p_left")))]
                          ),
                          _c(
                            "el-option",
                            {
                              attrs: {
                                value: "center",
                                label: _vm.$t("chart.p_center"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("chart.p_center")))]
                          ),
                          _c(
                            "el-option",
                            {
                              attrs: {
                                value: "end",
                                label: _vm.$t("chart.p_right"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("chart.p_right")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("vPosition"),
                          expression: "showProperty('vPosition')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.v_position") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: _vm.$t("chart.v_position") },
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase("vPosition")
                            },
                          },
                          model: {
                            value: _vm.sizeForm.vPosition,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm, "vPosition", $$v)
                            },
                            expression: "sizeForm.vPosition",
                          },
                        },
                        [
                          _c(
                            "el-option",
                            {
                              attrs: {
                                value: "start",
                                label: _vm.$t("chart.p_top"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("chart.p_top")))]
                          ),
                          _c(
                            "el-option",
                            {
                              attrs: {
                                value: "center",
                                label: _vm.$t("chart.p_center"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("chart.p_center")))]
                          ),
                          _c(
                            "el-option",
                            {
                              attrs: {
                                value: "end",
                                label: _vm.$t("chart.p_bottom"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("chart.p_bottom")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("scatterSymbol"),
                      expression: "showProperty('scatterSymbol')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.bubble_symbol") },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("chart.line_symbol") },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("scatterSymbol")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.scatterSymbol,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "scatterSymbol", $$v)
                        },
                        expression: "sizeForm.scatterSymbol",
                      },
                    },
                    _vm._l(_vm.lineSymbolOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.name, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("scatterSymbolSize"),
                      expression: "showProperty('scatterSymbolSize')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.bubble_size") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 1,
                      max: 40,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("scatterSymbolSize")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.scatterSymbolSize,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "scatterSymbolSize", $$v)
                      },
                      expression: "sizeForm.scatterSymbolSize",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("treemapWidth"),
                      expression: "showProperty('treemapWidth')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.width") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 0,
                      max: 100,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("treemapWidth")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.treemapWidth,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "treemapWidth", $$v)
                      },
                      expression: "sizeForm.treemapWidth",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("treemapHeight"),
                      expression: "showProperty('treemapHeight')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.height") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 0,
                      max: 100,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("treemapHeight")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.treemapHeight,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "treemapHeight", $$v)
                      },
                      expression: "sizeForm.treemapHeight",
                    },
                  }),
                ],
                1
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("mix"),
                      expression: "showProperty('mix')",
                    },
                  ],
                },
                [
                  _c(
                    "el-divider",
                    {
                      staticClass: "divider-style",
                      attrs: { "content-position": "center" },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.chart_bar")))]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.adapt") },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase("barDefault")
                            },
                          },
                          model: {
                            value: _vm.sizeForm.barDefault,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm, "barDefault", $$v)
                            },
                            expression: "sizeForm.barDefault",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("chart.adapt")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item form-item-slider",
                      attrs: { label: _vm.$t("chart.bar_width") },
                    },
                    [
                      _c("el-slider", {
                        attrs: {
                          disabled: _vm.sizeForm.barDefault,
                          "show-input": "",
                          "show-input-controls": false,
                          "input-size": "mini",
                          min: 1,
                          max: 80,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeBarSizeCase("barWidth")
                          },
                        },
                        model: {
                          value: _vm.sizeForm.barWidth,
                          callback: function ($$v) {
                            _vm.$set(_vm.sizeForm, "barWidth", $$v)
                          },
                          expression: "sizeForm.barWidth",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item form-item-slider",
                      attrs: { label: _vm.$t("chart.bar_gap") },
                    },
                    [
                      _c("el-slider", {
                        attrs: {
                          disabled: _vm.sizeForm.barDefault,
                          "show-input": "",
                          "show-input-controls": false,
                          "input-size": "mini",
                          min: 0,
                          max: 5,
                          step: 0.1,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeBarSizeCase("barGap")
                          },
                        },
                        model: {
                          value: _vm.sizeForm.barGap,
                          callback: function ($$v) {
                            _vm.$set(_vm.sizeForm, "barGap", $$v)
                          },
                          expression: "sizeForm.barGap",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-divider",
                    {
                      staticClass: "divider-style",
                      attrs: { "content-position": "center" },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.chart_line")))]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item form-item-slider",
                      attrs: { label: _vm.$t("chart.line_width") },
                    },
                    [
                      _c("el-slider", {
                        attrs: {
                          "show-input": "",
                          "show-input-controls": false,
                          "input-size": "mini",
                          min: 0,
                          max: 10,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeBarSizeCase("lineWidth")
                          },
                        },
                        model: {
                          value: _vm.sizeForm.lineWidth,
                          callback: function ($$v) {
                            _vm.$set(_vm.sizeForm, "lineWidth", $$v)
                          },
                          expression: "sizeForm.lineWidth",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.line_type") },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase("lineType")
                            },
                          },
                          model: {
                            value: _vm.sizeForm.lineType,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm, "lineType", $$v)
                            },
                            expression: "sizeForm.lineType",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "solid" } }, [
                            _vm._v(_vm._s(_vm.$t("chart.line_type_solid"))),
                          ]),
                          _c(
                            "el-radio-button",
                            { attrs: { label: "dashed" } },
                            [_vm._v(_vm._s(_vm.$t("chart.line_type_dashed")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.line_symbol") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: _vm.$t("chart.line_symbol") },
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase("lineSymbol")
                            },
                          },
                          model: {
                            value: _vm.sizeForm.lineSymbol,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm, "lineSymbol", $$v)
                            },
                            expression: "sizeForm.lineSymbol",
                          },
                        },
                        _vm._l(_vm.lineSymbolOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.name, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item form-item-slider",
                      attrs: { label: _vm.$t("chart.line_symbol_size") },
                    },
                    [
                      _c("el-slider", {
                        attrs: {
                          "show-input": "",
                          "show-input-controls": false,
                          "input-size": "mini",
                          min: 0,
                          max: 20,
                        },
                        on: { change: _vm.changeBarSizeCase },
                        model: {
                          value: _vm.sizeForm.lineSymbolSize,
                          callback: function ($$v) {
                            _vm.$set(_vm.sizeForm, "lineSymbolSize", $$v)
                          },
                          expression: "sizeForm.lineSymbolSize",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.line_smooth") },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase("lineSmooth")
                            },
                          },
                          model: {
                            value: _vm.sizeForm.lineSmooth,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm, "lineSmooth", $$v)
                            },
                            expression: "sizeForm.lineSmooth",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("chart.line_smooth")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-divider",
                    {
                      staticClass: "divider-style",
                      attrs: { "content-position": "center" },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.chart_scatter")))]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.bubble_symbol") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: _vm.$t("chart.line_symbol") },
                          on: {
                            change: function ($event) {
                              return _vm.changeBarSizeCase("scatterSymbol")
                            },
                          },
                          model: {
                            value: _vm.sizeForm.scatterSymbol,
                            callback: function ($$v) {
                              _vm.$set(_vm.sizeForm, "scatterSymbol", $$v)
                            },
                            expression: "sizeForm.scatterSymbol",
                          },
                        },
                        _vm._l(_vm.lineSymbolOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.name, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item form-item-slider",
                      attrs: { label: _vm.$t("chart.bubble_size") },
                    },
                    [
                      _c("el-slider", {
                        attrs: {
                          "show-input": "",
                          "show-input-controls": false,
                          "input-size": "mini",
                          min: 1,
                          max: 40,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeBarSizeCase("scatterSymbolSize")
                          },
                        },
                        model: {
                          value: _vm.sizeForm.scatterSymbolSize,
                          callback: function ($$v) {
                            _vm.$set(_vm.sizeForm, "scatterSymbolSize", $$v)
                          },
                          expression: "sizeForm.scatterSymbolSize",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("liquidShape"),
                      expression: "showProperty('liquidShape')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.liquid_shape") },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("chart.liquid_shape") },
                      on: {
                        change: function ($event) {
                          return _vm.changeBarSizeCase("liquidShape")
                        },
                      },
                      model: {
                        value: _vm.sizeForm.liquidShape,
                        callback: function ($$v) {
                          _vm.$set(_vm.sizeForm, "liquidShape", $$v)
                        },
                        expression: "sizeForm.liquidShape",
                      },
                    },
                    _vm._l(_vm.liquidShapeOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.name, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("liquidMax"),
                      expression: "showProperty('liquidMax')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.liquid_max") },
                },
                [
                  _c("el-input-number", {
                    attrs: { min: 1, size: "mini" },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("liquidMax")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.liquidMax,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "liquidMax", $$v)
                      },
                      expression: "sizeForm.liquidMax",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("liquidSize"),
                      expression: "showProperty('liquidSize')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.radar_size") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 1,
                      max: 100,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("liquidSize")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.liquidSize,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "liquidSize", $$v)
                      },
                      expression: "sizeForm.liquidSize",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("liquidOutlineBorder"),
                      expression: "showProperty('liquidOutlineBorder')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.liquid_outline_border") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 1,
                      max: 20,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("liquidOutlineBorder")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.liquidOutlineBorder,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "liquidOutlineBorder", $$v)
                      },
                      expression: "sizeForm.liquidOutlineBorder",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("liquidOutlineDistance"),
                      expression: "showProperty('liquidOutlineDistance')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.liquid_outline_distance") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 0,
                      max: 20,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("liquidOutlineDistance")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.liquidOutlineDistance,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "liquidOutlineDistance", $$v)
                      },
                      expression: "sizeForm.liquidOutlineDistance",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("liquidWaveLength"),
                      expression: "showProperty('liquidWaveLength')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.liquid_wave_length") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 10,
                      max: 500,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("liquidWaveLength")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.liquidWaveLength,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "liquidWaveLength", $$v)
                      },
                      expression: "sizeForm.liquidWaveLength",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("liquidWaveCount"),
                      expression: "showProperty('liquidWaveCount')",
                    },
                  ],
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.liquid_wave_count") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                      min: 2,
                      max: 10,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeBarSizeCase("liquidWaveCount")
                      },
                    },
                    model: {
                      value: _vm.sizeForm.liquidWaveCount,
                      callback: function ($$v) {
                        _vm.$set(_vm.sizeForm, "liquidWaveCount", $$v)
                      },
                      expression: "sizeForm.liquidWaveCount",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }